import React from 'react';

import CircledDottedScheme8 from 'components/Schemes/CircledDottedScheme/8dots/CircledDottedScheme8';

const schemeData = [
  'Compliance with ONC – Authorized testing\nand Certification Body',
  'Two-factor authentication',
  'Personnel security training',
  'Security system upgrades',
  'Regular security audits',
  'API-shielding for integrated apps',
  'Compliance with HIPAA, HITECH,\nand CDC recommendations',
  'Data encryption',
];

export const SecurityScheme = () => (
  <CircledDottedScheme8 items={schemeData} innerTitle="EHR security" containerClass="pediatric-ehr-scheme-block" />
);
